/**
 * export namespace
 */
export const NAMESPACE = 'SEND';
/**
 * SEND_WEBCHAT_MESSAGE
 */
export const SEND_WEBCHAT_MESSAGE = `webchat/${NAMESPACE}/SEND_WEBCHAT_MESSAGE`;

/**
 * SEND_WEBCHAT_MESSAGE_SUCCESS
 */
export const SEND_WEBCHAT_MESSAGE_SUCCESS = `webchat/${NAMESPACE}/SEND_WEBCHAT_MESSAGE_SUCCESS`;

/**
 * SEND_WEBCHAT_MESSAGE_FAILED
 */
export const SEND_WEBCHAT_MESSAGE_FAILED = `webchat/${NAMESPACE}/SEND_WEBCHAT_MESSAGE_FAILED`;
